import type { PropsWithChildren } from 'react';
import styles from './NotificationBanner.module.scss';

type NotificationBannerFrameProps = PropsWithChildren<{
  testId?: string;
}>;

export const NotificationBannerFrame: React.FC<NotificationBannerFrameProps> = ({ children, testId }) => {
  return (
    <div className={styles.wrapper} role="status" data-testid={testId}>
      <div className={styles.banner} data-name="notification-banner">
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};
